import type { FeedbackAdapter } from '@assistant-ui/react';
import type { AgentWorkbenchFeedback } from './agent-workbench-analytics.js';

/**
 * Feedback adapter that forwards a thumbs up/down to a recorder.
 *
 * Registering any adapter is what enables assistant-ui's feedback controls and
 * makes it remember the choice for the session; the rating is not stored, so it
 * is forgotten when the conversation is next loaded fresh.
 */
export class AgentWorkbenchFeedbackAdapter implements FeedbackAdapter {
	/**
	 * @param getConversationId - Reads the thread's current backend id, undefined before it has one.
	 * @param record - Receives each rating.
	 */
	public constructor(
		private readonly getConversationId: () => string | undefined,
		private readonly record: (feedback: AgentWorkbenchFeedback) => void,
	) {}

	/**
	 * Forwards one rating to the recorder.
	 *
	 * @param feedback - The rated message and which way it was rated.
	 */
	public submit({ message, type }: Parameters<FeedbackAdapter['submit']>[0]): void {
		this.record({ messageId: message.id, conversationId: this.getConversationId(), rating: type });
	}
}
